module.exports = __webpack_public_path__ + "assets/images/sleep_g.fdeb3894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/sleep_g.png
// module id = 763
// module chunks = 1